import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Bars as MenuIcon } from "flowbite-react-icons/outline";
import AccountIcon from "../Icons/AccountIcon";
import zebrainIcon from "url:shared-assets/icons/zebrain.svg";
import logoTextIcon from "url:shared-assets/icons/primary/logoText.svg";
import NavMini from "../NavMini/NavMini";
import NavMenu from "../NavMenu/NavMenu";
import { useAtom } from "jotai";
import { pictureAtom, languageAtom } from "../../jotai_state";
import Api from "../../services/Api";
import {CONFIG} from "../../constants";

interface NavbarProps {
  showMenu?: boolean;
  loggedIn?: boolean;
  i18n: any; // Replace 'any' with the correct type if available
  badges: boolean;
  debug: boolean;
}

const Navbar: React.FC<NavbarProps> = ({
  showMenu = true,
  i18n,
  badges,
  loggedIn,
  debug,
}) => {
  const api = Api.getInstance();
  const navigate = useNavigate();
  const [showNavMini, setShowNavMini] = useState<boolean>(false);
  const [picture] = useAtom(pictureAtom);
  const [lang, setLang] = useAtom(languageAtom);
  const [showSidebar, setShowSidebar] = useState(false);

  console.log('showMenu ' + showMenu + ' loggedIn ' + loggedIn);

  useEffect(() => {

    if (i18n.language !== lang) {
      console.log("changing language to " + lang + " from " + i18n.language);
      localStorage.setItem("language", lang);
      i18n.changeLanguage(lang);
    } else {
      console.log("keeping " + lang + " === " + i18n.language);
    }

  }, [lang]);

  const changeLanguage = () => {
    const newLang = lang === "en" ? "sv" : "en";
    api.get(CONFIG.USER_TYPE + "/change_language/" + newLang).then(() => {
      setLang(newLang);
      localStorage.setItem("language", newLang);
      i18n.changeLanguage(newLang);
    });
  };

 
  const handleMenuItemClick = () => setShowSidebar(false);
  return (
    <header className="w-full bg-indigo-1000 text-sm relative">
      <div className="flex justify-between items-center flex-nowrap w-full p-4 desktop:p-6">
        {loggedIn ? (
          <img
            onClick={() => navigate("/")}
            className="cursor-pointer h-6 w-6"
            src={zebrainIcon}
            alt="logo"
          />
        ) : (
          <a
            className="flex flex-col justify-center"
            href={"https://www.zebrain.se"}
            aria-label="Brand"
          >
            <img src={logoTextIcon} alt="logo" />
          </a>
        )}
        <div className="flex">
          {loggedIn && (
            <div
              className="h-8 w-8 bg-white rounded-full flex items-center justify-center cursor-pointer relative"
              onClick={() => setShowNavMini(!showNavMini)}
            >
              {picture ? (
                <img
                  src={picture}
                  alt="menus"
                  className="h-8 w-8 rounded-full"
                />
              ) : (
                <AccountIcon alt="menus" className="h-5 w-5" />
              )}
              {showNavMini && (
                <>
                  <div
                    className="fixed z-40"
                    style={{ top: 0, left: 0, width: "100vw", height: "100vh" }}
                    onClick={() => setShowNavMini(false)}
                  ></div>
                  <div className="absolute z-50" style={{ right: 0, top: 32 }}>
                    <NavMini changeLanguage={changeLanguage} debug={debug}/>
                  </div>
                </>
              )}
            </div>
          )}

          <div className={"ml-4 relative " + (showMenu ? "block" : "hidden")}>
            <button
              type="button"
              className="text-gray-500 hover:text-gray-600 cursor-pointer"
              onClick={() => setShowSidebar(true)}
              aria-label="Toggle navigation"
            >
              <span className="sr-only">Toggle Navigation</span>
              <MenuIcon className="size-8 text-white" aria-hidden="true" />
            </button>
            {badges && (
              <div
                className="h-2 w-2 rounded-full bg-cherry-500 absolute"
                style={{ top: "1px", right: "2px" }}
              />
            )}
          </div>
        </div>
      </div>

      {/* Overlay for background dimming */}
      <div
        className={`
          fixed inset-0 z-59
          bg-indigo-1000 bg-opacity-80
          transition-opacity duration-300
          ${showSidebar ? "opacity-80 pointer-events-auto" : "opacity-0 pointer-events-none"}
        `}
        onClick={() => setShowSidebar(false)}
        aria-hidden="true"
      />

      {/* Sidebar */}
      <div
        id="docs-sidebar"
        className={`
          fixed top-0 right-0 bottom-0
          w-96 max-desktop:w-full
          z-60
          bg-indigo-900
          flex flex-col p-4 desktop:p-6
          transform transition-transform duration-300 ease-in-out
          ${showSidebar ? "translate-x-0" : "translate-x-full"}
          shadow-lg
          overflow-y-auto
          scrollbar-thin scrollbar-thumb-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-200
          dark:[&::-webkit-scrollbar-track]:bg-indigo-800 dark:[&::-webkit-scrollbar-thumb]:bg-gray-500
        `}
        role="dialog"
        aria-modal="true"
        style={{ pointerEvents: showSidebar ? "auto" : "none" }}
      >
        <div className="flex justify-between items-center mb-4">
          <img
            onClick={() => navigate("/")}
            className="cursor-pointer h-6 w-6"
            src={zebrainIcon}
            alt="logo"
          />
          <button
            type="button"
            className="text-white hover:text-white cursor-pointer"
            onClick={() => setShowSidebar(false)}
            aria-label="Close navigation"
          >
            <span className="sr-only">Close Navigation</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <nav
          className="hs-accordion-group w-full flex flex-col justify-between grow"
          data-hs-accordion-always-open="true"
        >
          <NavMenu menuClick={handleMenuItemClick} showSidebar={showSidebar}/>
        </nav>
      </div>
      <hr className="border-indigo-800" />
    </header>
  );
};

export default Navbar;
